'use strict';

import {reportingModel} from "@js/models/reportingmodel";

export class ReportingTableCtrl
{
	
	reportings = {
		t1: [],
		t2: [],
		t3: []
	};
	
	constructor($scope, $filter, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.$mdDialog = $mdDialog;		
		this.setReportings(this.jsDataService.get('reportings', {}));
	}

	setReportings(reportings){
		this.reportings = {
			t1: [],
			t2: [],
			t3: []
		};
		if(typeof(reportings.t1) !== 'undefined' || typeof(reportings.t2) !== 'undefined' || typeof(reportings.t3) !== 'undefined'){
			for(let id in reportings){
				for(let reportingData of reportings[id]){
					this.reportings[id].push(new reportingModel(reportingData, this.$filter, this.jsDataService));
				}
			}
		}
	}
	
	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}
	
}